// extracted by mini-css-extract-plugin
export default {"userName":"ReviewItem_userName__Vq8HM","content":"ReviewItem_content__NeRsP"};